<div
data-test="mono-common-progress-bar"
tabindex="-1"
*ngIf="showProgressBar"
class="progress-bar"
[ngClass]="hideOnMobile ? 'hide-for-mobile' : ''"
>
<div
  class="progress-bar__outer"
  role="progressbar"
  [attr.aria-valuenow]="progressPercentage"
  aria-valuemin="0"
  aria-valuemax="100"
>
  <div class="progress-bar__inner success" [style.width.%]="progressPercentage" aria-hidden="true">
  </div>
</div>
<div *ngIf="showProgressPercentage" class="flex-container align-right align-middle progress-bar-info">
    <ng-container *ngIf="progressPercentage !== progressPercentage">
      {{ translate("Calculating progress") | async }}
    </ng-container>
    <ng-container *ngIf="progressPercentage > 0 && progressPercentage < 100">
      {{ translate(language === defaultLanguage ? progressPercentage + "% complete" : (context ? context + " " + progressPercentage + "% complete" : progressPercentage + "% complete")) | async }}
    </ng-container>
    <ng-container *ngIf="progressPercentage < 1 && progressPercentage!==undefined">{{ translate("Not started") | async }}</ng-container>
    <ng-container *ngIf="progressPercentage === 100">
      {{ translate(language === defaultLanguage ? "completed" : (context ? context + " completed" : "completed")) | async }}
    </ng-container>
</div>
</div>
